<footer id="footer">
  <div class="custom-shape-divider-top-1739612572">
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1200 120"
      preserveAspectRatio="none">
      <path
        d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
        class="shape-fill"></path>
    </svg>
  </div>
  <div id="sBeneficiosAdicionales" class="stellar-section">
    <div class="stellar-block overlap-wave-bottom">
      <div class="container">
        <div class="grid grid-nogutter">
          <div class="col-12 text-center p-4">
            <div
              class="text-2xl uppercase font-bold text-white"
              i18n="@@footer.title">
              Pizzas a domicilio
            </div>
          </div>
        </div>

        <div class="grid grid-nogutter">
          <div class="col-12 grid grid-nogutter">
            <div class="col-12 sm:col-6 text-center md:text-left p-4">
              <div class="max-w-18rem md:max-w-full m-auto">
                <p class="uppercase poppins title" i18n="@@footer.address">
                  <!-- Dirección y teléfono -->
                  Haz tu pedido en just eat
                </p>

                <div
                  class="flex justify-content-start flex-wrap align-items-center">
                  <i class="ph ph-map-pin mr-2"></i>
                  <span class="pr-2">Palma</span>
                  <span>Islas Baleares, España</span>
                </div>

                <br />

                <!-- <div
                  class="flex justify-content-start flex-wrap align-items-center">
                  <i class="ph ph-phone mr-2"></i>
                  <a href="tel:+34696000000">+34 </a>
                </div>
                <br /> -->
                <!-- <div class="flex justify-content-start align-items-center">
                  <i class="ph ph-envelope mr-2"></i>
                  <span>info&#64;pizzaencasa.com</span>
                  <br />
                </div> -->
                <a
                  href="https://www.just-eat.es/restaurants-pizza-en-casa-palma/menu">
                  <!-- <p-button
                    label="Reservar"
                    styleClass="p-button-rounded p-button-sm">
                  </p-button> -->
                  <!-- <p-button size="large" [outlined]="true"> -->
                  <img
                    src="assets/img/logotipos/just-eat-seeklogo@42w.png"
                    alt="Logotipo Just Eat"
                    class="w-3rem" />
                  <!-- <span> Haz tu pedido en Just Eat </span> -->
                  <!-- </p-button> -->
                </a>
              </div>
            </div>

            <div class="col-12 sm:col-6 text-center md:text-left p-4 mb-4">
              <p class="uppercase poppins title" i18n="@@footer.social.title">
                Redes sociales:
              </p>
              <p i18n="@@footer.social.text">
                Siguenos en nuestras redes sociales
              </p>
              <a
                data-hover="Facebook"
                href="https://www.facebook.com"
                target="_blank"
                class="sm-link"
                ><i class="ph ph-facebook-logo fa-lg"></i
              ></a>
              &nbsp;&nbsp;
              <a
                data-hover="Instagram"
                href="https://www.instagram.com/"
                target="_blank"
                class="sm-link"
                ><i class="ph ph-instagram-logo fa-lg"></i
              ></a>
            </div>
          </div>
        </div>

        <div class="grid grid-nogutter mt-4">
          <div
            class="col-12 flex align-items-center justify-content-center mb-4">
            <img
              src="assets/img/logotipos/logo-main-horizontal-full-v2.jpg"
              alt="Pizza en casa Logo"
              class="logotipo rounded" />
          </div>

          <div class="col-12 text-sm p-4">
            <!-- <a
              href="aviso-legal"
              class="no-link-style"
              i18n="@@footer.links.legal-warning"
              >Aviso legal</a
            >
            | -->
            <a
              href="cookies"
              class="no-link-style link"
              i18n="@@footer.links.cookies">
              Política de cookies
            </a>
            <!-- |
            <a
              href="privacidad"
              class="no-link-style"
              i18n="@@footer.links.privacy">
              Política de privacidad
            </a> -->
            <!-- |
            <a href="terminos" class="no-link-style" i18n="@@footer.links.terms"
              >Términos y condiciones</a
            >
            <p class="info wow fadeInUp" data-wow-delay=".4s">
              <span id="copyright-year">Pizza En Casa © 2025.</span>
              <span i18n="@@footer.texts.rights"
                >Todos los derechos reservados</span
              >
            </p> -->
            |
            <a
              href="login"
              class="no-link-style"
              i18n="@@footer.links.private_access">
              Acceso privado
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>

<p-scrollTop />
